import { html, defineElement, TemplateElement, i18n } from '@webtides/element-js';

class ProductCount extends TemplateElement {
    constructor() {
        super({ shadowRender: false });
    }

    properties() {
        return {
            count: 0,
            singular: i18n('product.count.singular', 'Produkt'),
            plural: i18n('product.count.plural', 'Produkte'),
        };
    }

    get label() {
        return this.count === 1 ? this.singular : this.plural;
    }

    template() {
        return html`
            <div>${this.count !== 0 ? `${this.count} ${this.label}` : ''}</div>
        `;
    }
}

defineElement('product-count', ProductCount);
